import React from 'react';
import styled from 'styled-components';
import { white } from '@engage/colors';
import { useCta } from '@members/copy';
import { Cta } from '@members/copy/models.generated/Cta';
import { Chevron, Orientation } from '@members/icons';

const StyledChevron = styled(Chevron)`
  fill: ${props => props.color ?? white};
  width: 20px;
`;

const BackButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ color, ...props }, ref) => (
    <button aria-label={useCta(Cta.Back)} {...props} ref={ref}>
      <StyledChevron color={color} orientation={Orientation.Left} />
    </button>
  ),
);

BackButton.displayName = 'BackButton';

const StyledBackButton = styled(BackButton)`
  align-items: center;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;
`;

export default StyledBackButton;

type Props = {
  className?: string;
  color?: string;
} & React.HTMLAttributes<HTMLButtonElement>;
